import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import get from "lodash/get";
import { object } from "prop-types";
import { MenuItem } from "../menu-item";
import { AppLogo } from "../app-logo";

import "./footer.m.css";
import useViewPort from "../../../hook/useViewPort";
import RadioPlayerCustomV3 from "../../molecules/radio-player-custom-v3";
import { Link } from "@quintype/components";
import { FOOTER_ASIAKASPALVELU, FOOTER_LIITANAISET, FOOTER_OHJEET_JA_APUA, FOOTER_PRIVACY_POLICY, FOOTER_TILAUS_JA_OHJEET } from "../../store/actions";

const FooterBase = ({ menu, pageType }) => {
  const placeholderMenus = menu.filter((item) => (item["item-type"] = "placeholder"));
  const { viewports } = useViewPort();
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const dispatch = useDispatch();
  return (
    <div>
      <div styleName="footer">
        <div styleName="icons-wrapper">
          <div styleName="main-logo">
            <AppLogo />
            <style>
              {`
                #footer .app-logo {
                  height: 110px;
                }
                @media only screen and (max-width: 640px) {
                  #footer .app-logo {
                    height: 80px;
                  }
                }
              `}
            </style>
          </div>

          <div styleName="social-icons">
            <div>
              <a target="_blank" href="https://www.instagram.com/deiplusvirallinen">
                <i class="ri-instagram-line"></i>
              </a>
              <a target="_blank" href="https://www.facebook.com/deiplusvirallinen">
                <i class="ri-facebook-line"></i>
              </a>
              <a target="_blank" href="https://www.tiktok.com/@deiplusvirallinen">
                <i class="ri-tiktok-line"></i>
              </a>
            </div>
            <div>
              <a target="_blank" href="https://www.youtube.com/@deiplusvirallinen">
                <i class="ri-youtube-line"></i>
              </a>
              <a target="_blank" href="https://fi.linkedin.com/company/radio-dei">
                <i class="ri-linkedin-line"></i>
              </a>
              <a target="_blank" href="https://x.com/dei_plus">
                <i class="ri-twitter-x-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div styleName="footer-lists-container">
          <div styleName="list-groups">
            <div styleName="footer-section">
              <h2>OHJEET JA APUA</h2>
              <div styleName="links-style-wrapper">
                <a styleName="style-links" href="/usein-kysyttya">Usein kysyttyä</a>
                <a styleName="style-links" href="/toimintaperiaatteet">Toimintaperiaatteet</a>
              </div>
            </div>

            <div styleName="footer-section">
              <h2>YHTEYSTIEDOT</h2>
              <div styleName="links-style-wrapper">
                <a styleName="style-links" href="/asiakaspalvelu">Asiakaspalvelu</a>
                <a styleName="style-links" href="/mediamyynti">Mediamyynti</a>
              </div>
            </div>
          </div>

          <div styleName="list-groups">
            <div styleName="footer-section">
              <h2>KÄYTTÖEHDOT</h2>
              <div styleName="links-style-wrapper">
                <a styleName="style-links" href="/tilaus-ja-kayttoehdot">Palvelun säännöt</a>
                <a styleName="style-links" href="/tilaushinnat">Tilaushinnat</a>
              </div>
            </div>

            <div styleName="footer-section">
              <h2>MAINOSTAJILLE</h2>
              <div styleName="links-style-wrapper">
                <a styleName="style-links" href="/mediakortti">Mediakortti</a>
                <a styleName="style-links" href="/kaupallinen-yhteistyo">Kaupallinen yhteistyö</a>
              </div>
            </div>
          </div>

          <div styleName="list-groups">
            <div styleName="footer-section">
              <h2>TURVALLISUUS</h2>
              <div styleName="links-style-wrapper">
                  <a styleName="style-links" href="/tietoturvaselosteet">Tietosuojaseloste</a>
                  <a styleName="style-links" href="/liitannaiset">Liitännäiset</a>
              </div>
            </div>

            <div styleName="footer-section">
              <h2>DEI KAUPPA</h2>
              <div styleName="links-style-wrapper">
                <a styleName="style-links" href="/tuotteet-ja-lahjavinkit">Tuotteet ja lahjavinkit</a>
              </div>
            </div>
          </div>

          <div styleName="list-groups">
            <div styleName="footer-section">
              <h2>KRISTITYT YHDESSÄ RY</h2>
              <div styleName="links-style-wrapper">
                <a styleName="style-links" href="/tulejaseneksi">Tule jäseneksi</a>
                <a styleName="style-links no-dash" href="/">&nbsp;</a>
              </div>
            </div>

            <div styleName="footer-section">
              <h2>KRISTILLINEN MEDIA OY</h2>
              <div styleName="links-style-wrapper">
                <a styleName="style-links" href="/anti">Osakeanti</a>
                <a styleName="style-links no-dash" href="/">&nbsp;</a>
              </div>
            </div>
          </div>
        </div>

        <div styleName="footer-section ylos-custom">
          <div styleName="links-style-wrapper">
            {showButton && (
              <button
                styleName="up-button-mobile"
                onClick={() =>
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  })
                }
              >
                <div styleName="up-button-text">
                  YLÖS <i className="ri-arrow-up-line"></i>
                </div>
              </button>
            )}
          </div>
        </div>

        <div styleName="copyright-info">
          © Copyright Kristillinen Media Oy - Dei Plus 2025
        </div>
      </div>
      <div styleName="footer-section" style={{position: "relative", zIndex: 1}}>
        <RadioPlayerCustomV3 pageType={pageType} />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu", "footer"], []),
    pageType: get(state, ["qt", "pageType"], null),
  };
}

FooterBase.propTypes = {
  menu: object,
};

export const Footer = connect(mapStateToProps, null)(FooterBase);
